import React, { useEffect, useState, useRef } from 'react'
import { MapContainer, TileLayer, Polyline, Marker, Popup, useMap } from 'react-leaflet'
import L from 'leaflet'
import axios from 'axios'
import 'leaflet/dist/leaflet.css'

const API = process.env.REACT_APP_API_URL || 'http://localhost:3001/api'

function AjustarBounds({ pontos }: { pontos: any[] }) {
  const map = useMap()
  useEffect(() => {
    if (pontos.length > 1) {
      const bounds = L.latLngBounds(pontos.map((p:any) => [p.latitude, p.longitude]))
      map.fitBounds(bounds, { padding: [40, 40] })
    }
  }, [pontos])
  return null
}

const corPorVelocidade = (vel: number) => {
  if (vel === 0)   return '#64748b'
  if (vel <= 40)   return '#22c55e'
  if (vel <= 80)   return '#eab308'
  if (vel <= 110)  return '#f97316'
  return '#ef4444'
}

export default function Replay({ params }: { params?: any }) {
  const [ativos, setAtivos]         = useState<any[]>([])
  const [clientesLista, setClientesLista] = useState<any[]>([])
  const [clienteSel, setClienteSel] = useState('')
  const usuarioLogado = JSON.parse(localStorage.getItem('moobi_usuario')||'{}')
  const ehSuperadmin = usuarioLogado?.perfil === 'superadmin'
  const [ativoSel, setAtivoSel]     = useState('')
  const [dataInicio, setDataInicio] = useState(() => {
    const d = new Date(); d.setHours(0,0,0,0)
    return d.toISOString().slice(0,16)
  })
  const [dataFim, setDataFim]       = useState(() => new Date().toISOString().slice(0,16))
  const [posicoes, setPosicoes]     = useState<any[]>([])
  const [segmentosRota, setSegmentosRota] = useState<any[]>([])
  const [carregandoRota, setCarregandoRota] = useState(false)
  const [resumo, setResumo]         = useState<any>(null)
  const [loading, setLoading]       = useState(false)
  const [posAtual, setPosAtual]     = useState(0)
  const [tocando, setTocando]       = useState(false)
  const [velocidade, setVelocidade] = useState(10)
  const [paradas, setParadas]       = useState<any[]>([])
  const [abaAtiva, setAbaAtiva]     = useState<'resumo'|'velocidade'|'paradas'>('resumo')
  const [minParada, setMinParada]     = useState(3)
  const [minOcioso, setMinOcioso]       = useState(10)
  const [paradasMotor, setParadasMotor] = useState<any[]>([])
  const intervaloRef                = useRef<any>(null)

  useEffect(() => {
    if (params?.ativo_id) {
      setAtivoSel(params.ativo_id)
      const ini = params.inicio ? params.inicio.substring(0,16).replace('T',' ') : ''
      const fim = params.fim ? params.fim.substring(0,16).replace('T',' ') : ''
      if (ini) setDataInicio(ini)
      if (fim) setDataFim(fim)
      setLoading(true)
      setTimeout(async () => {
        try {
          const [posResp, resumoResp] = await Promise.all([
            axios.get(`${API}/posicoes/${params.ativo_id}/historico`, {
              params: { inicio: params.inicio, fim: params.fim }
            }),
            axios.get(`${API}/posicoes/${params.ativo_id}/resumo`, {
              params: { inicio: params.inicio, fim: params.fim }
            }).catch(()=>({data:null}))
          ])
          if (posResp.data && posResp.data.length > 0) {
            setPosicoes(posResp.data)
            setPosAtual(0)
            if (resumoResp.data) setResumo(resumoResp.data)
            buscarRotaOSRM(params.ativo_id, params.inicio, params.fim)
            // Calcular paradas
            const pos = posResp.data
            const paroList: any[] = []
            const motorList2: any[] = []
            let inicioParada: any = null
            let inicioMotor2: any = null
            for (let i = 0; i < pos.length; i++) {
              const vel = parseFloat(pos[i].velocidade||0)
              if (vel < 2) { if (!inicioParada) inicioParada = pos[i] }
              else { if (inicioParada) { const d=(new Date(pos[i].data_hora).getTime()-new Date(inicioParada.data_hora).getTime())/60000; if(d>=minParada) paroList.push({inicio:inicioParada.data_hora,fim:pos[i].data_hora,duracao_min:Math.round(d),latitude:inicioParada.latitude,longitude:inicioParada.longitude,endereco:inicioParada.endereco,motor_ligado:inicioParada.ignicao}); inicioParada=null } }
              if (pos[i].ignicao && vel < 2) { if (!inicioMotor2) inicioMotor2 = pos[i] }
              else { if (inicioMotor2) { const d=(new Date(pos[i].data_hora).getTime()-new Date(inicioMotor2.data_hora).getTime())/60000; if(d>=minParada) motorList2.push({inicio:inicioMotor2.data_hora,fim:pos[i].data_hora,duracao_min:Math.round(d),latitude:inicioMotor2.latitude,longitude:inicioMotor2.longitude}); inicioMotor2=null } }
            }
            setParadas(paroList)
            setParadasMotor(motorList2)
          } else {
            alert("Nenhuma posição encontrada para o período selecionado")
          }
        } catch(e) { console.error(e) }
        finally { setLoading(false) }
      }, 300)
    }
  }, [params])

  useEffect(() => {
    axios.get(`${API}/ativos`).then(r => setAtivos(r.data)).catch(() => {})
    axios.get(`${API}/clientes`).then(r => setClientesLista(r.data||[])).catch(() => {})
    return () => clearInterval(intervaloRef.current)
  }, [])

  useEffect(() => {
    if (tocando) {
      intervaloRef.current = setInterval(() => {
        setPosAtual(p => {
          if (p >= posicoes.length - 1) { setTocando(false); return p }
          return p + 1
        })
      }, 1000 / velocidade)
    } else {
      clearInterval(intervaloRef.current)
    }
    return () => clearInterval(intervaloRef.current)
  }, [tocando, velocidade, posicoes.length])

  const buscarRotaOSRM = async (ativoId: string, dtInicio: string, dtFim: string) => {
    setCarregandoRota(true)
    setSegmentosRota([])
    try {
      const resp = await axios.get(`${API}/posicoes/${ativoId}/trajeto-rotas`, {
        params: { inicio: dtInicio, fim: dtFim }
      })
      setSegmentosRota(resp.data?.segmentos || [])
    } catch (e) {
      console.error('Erro ao buscar rota OSRM:', e)
      setSegmentosRota([])
    } finally {
      setCarregandoRota(false)
    }
  }

  const buscarTrajeto = async () => {
    if (!ativoSel) return alert('Selecione um veículo')
    setLoading(true)
    setPosicoes([])
    setResumo(null)
    setPosAtual(0)
    setTocando(false)
    try {
      const [posResp, resumoResp] = await Promise.all([
        axios.get(`${API}/posicoes/${ativoSel}/historico`, {
          params: { inicio: new Date(dataInicio).toISOString(), fim: new Date(dataFim).toISOString() }
        }),
        axios.get(`${API}/posicoes/${ativoSel}/resumo`, {
          params: { inicio: new Date(dataInicio).toISOString(), fim: new Date(dataFim).toISOString() }
        })
      ])
      const pos = posResp.data
      setPosicoes(pos)
      setResumo(resumoResp.data)
      buscarRotaOSRM(ativoSel, new Date(dataInicio).toISOString(), new Date(dataFim).toISOString())

      // Calcular paradas e motor ocioso
      const paroList: any[] = []
      const motorList: any[] = []
      let inicioParada: any = null
      let inicioMotor: any = null
      for (let i = 0; i < pos.length; i++) {
        const vel = parseFloat(pos[i].velocidade||0)
        const ign = pos[i].ignicao
        if (vel < 2) {
          if (!inicioParada) inicioParada = pos[i]
        } else {
          if (inicioParada) {
            const durMin = (new Date(pos[i].data_hora).getTime() - new Date(inicioParada.data_hora).getTime()) / 60000
            if (durMin >= minParada) paroList.push({
              inicio: inicioParada.data_hora, fim: pos[i].data_hora,
              duracao_min: Math.round(durMin), latitude: inicioParada.latitude,
              longitude: inicioParada.longitude, endereco: inicioParada.endereco,
              motor_ligado: inicioParada.ignicao
            })
            inicioParada = null
          }
        }
        // Motor ocioso: usa ignicao se disponível, senão usa todas as paradas
        const temIgn = pos.some((p:any)=>p.ignicao===true)
        if ((temIgn ? ign : true) && vel < 2) {
          if (!inicioMotor) inicioMotor = pos[i]
        } else {
          if (inicioMotor) {
            const durMin = (new Date(pos[i].data_hora).getTime() - new Date(inicioMotor.data_hora).getTime()) / 60000
            if (durMin >= minParada) motorList.push({
              inicio: inicioMotor.data_hora, fim: pos[i].data_hora,
              duracao_min: Math.round(durMin), latitude: inicioMotor.latitude,
              longitude: inicioMotor.longitude, endereco: inicioMotor.endereco
            })
            inicioMotor = null
          }
        }
      }
      setParadas(paroList)
      setParadasMotor(motorList)
    } catch (e) {
      alert('Erro ao buscar trajeto')
    } finally { setLoading(false) }
  }

  const formatarTempo = (min: number) => {
    if (min < 60) return `${min}min`
    return `${Math.floor(min/60)}h ${min%60}min`
  }

  // Recalcula as paradas sempre que as posições ou o filtro de minutos mudarem
  useEffect(() => {
    if (!posicoes.length) { setParadas([]); setParadasMotor([]); return }
    const paroList: any[] = []
    const motorList: any[] = []
    let inicioParada: any = null
    let inicioMotor: any = null
    const temIgn = posicoes.some((p:any) => p.ignicao === true)
    for (let i = 0; i < posicoes.length; i++) {
      const vel = parseFloat(posicoes[i].velocidade || 0)
      const ign = posicoes[i].ignicao
      if (vel < 2) {
        if (!inicioParada) inicioParada = posicoes[i]
      } else {
        if (inicioParada) {
          const durMin = (new Date(posicoes[i].data_hora).getTime() - new Date(inicioParada.data_hora).getTime()) / 60000
          if (durMin >= minParada) paroList.push({
            inicio: inicioParada.data_hora, fim: posicoes[i].data_hora,
            duracao_min: Math.round(durMin), latitude: inicioParada.latitude,
            longitude: inicioParada.longitude, endereco: inicioParada.endereco,
            motor_ligado: inicioParada.ignicao
          })
          inicioParada = null
        }
      }
      if ((temIgn ? ign : true) && vel < 2) {
        if (!inicioMotor) inicioMotor = posicoes[i]
      } else {
        if (inicioMotor) {
          const durMin = (new Date(posicoes[i].data_hora).getTime() - new Date(inicioMotor.data_hora).getTime()) / 60000
          if (durMin >= minParada) motorList.push({
            inicio: inicioMotor.data_hora, fim: posicoes[i].data_hora,
            duracao_min: Math.round(durMin), latitude: inicioMotor.latitude,
            longitude: inicioMotor.longitude, endereco: inicioMotor.endereco
          })
          inicioMotor = null
        }
      }
    }
    if (inicioParada) {
      const ultimo = posicoes[posicoes.length-1]
      const durMin = (new Date(ultimo.data_hora).getTime() - new Date(inicioParada.data_hora).getTime()) / 60000
      if (durMin >= minParada) paroList.push({
        inicio: inicioParada.data_hora, fim: ultimo.data_hora,
        duracao_min: Math.round(durMin), latitude: inicioParada.latitude,
        longitude: inicioParada.longitude, endereco: inicioParada.endereco,
        motor_ligado: inicioParada.ignicao
      })
    }
    setParadas(paroList)
    setParadasMotor(motorList)
  }, [posicoes, minParada])

  const posExibida = posicoes[posAtual]

  // Calcular km total do trajeto pelo Haversine
  const kmTotal = React.useMemo(() => {
    if (posicoes.length < 2) return 0
    let total = 0
    for (let i = 0; i < posicoes.length - 1; i++) {
      const lat1 = parseFloat(posicoes[i].latitude), lon1 = parseFloat(posicoes[i].longitude)
      const lat2 = parseFloat(posicoes[i+1].latitude), lon2 = parseFloat(posicoes[i+1].longitude)
      if (isNaN(lat1)||isNaN(lat2)) continue
      const R = 6371, dLat = (lat2-lat1)*Math.PI/180, dLon = (lon2-lon1)*Math.PI/180
      const a = Math.sin(dLat/2)**2 + Math.cos(lat1*Math.PI/180)*Math.cos(lat2*Math.PI/180)*Math.sin(dLon/2)**2
      total += R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a))
    }
    return total
  }, [posicoes])

  const segmentos: any[] = []
  for (let i = 0; i < posicoes.length - 1; i++) {
    segmentos.push({
      pontos: [[posicoes[i].latitude, posicoes[i].longitude],[posicoes[i+1].latitude, posicoes[i+1].longitude]],
      cor: corPorVelocidade(posicoes[i].velocidade || 0)
    })
  }
  // Linha completa do trajeto (para o contorno/profundidade harmônico)
  const linhaCompleta: [number,number][] = posicoes.map((p:any) => [parseFloat(p.latitude), parseFloat(p.longitude)])
  // Calcula o ângulo (bearing) entre dois pontos geográficos, em graus
  const calcularBearing = (lat1:number, lon1:number, lat2:number, lon2:number) => {
    const toRad = (d:number) => d * Math.PI / 180
    const toDeg = (r:number) => r * 180 / Math.PI
    const dLon = toRad(lon2 - lon1)
    const y = Math.sin(dLon) * Math.cos(toRad(lat2))
    const x = Math.cos(toRad(lat1))*Math.sin(toRad(lat2)) - Math.sin(toRad(lat1))*Math.cos(toRad(lat2))*Math.cos(dLon)
    return (toDeg(Math.atan2(y, x)) + 360) % 360
  }
  // Distribui setas de sentido ao longo do trajeto, espaçadas pela distância acumulada (não por índice)
  const setasSentido = React.useMemo(() => {
    if (posicoes.length < 2) return []
    const setas: { lat:number, lon:number, angulo:number }[] = []
    const ESPACAMENTO_KM = Math.max(0.3, kmTotal / 40)
    let acumulado = 0
    for (let i = 0; i < posicoes.length - 1; i++) {
      const lat1 = parseFloat(posicoes[i].latitude), lon1 = parseFloat(posicoes[i].longitude)
      const lat2 = parseFloat(posicoes[i+1].latitude), lon2 = parseFloat(posicoes[i+1].longitude)
      if (isNaN(lat1)||isNaN(lat2)) continue
      const R = 6371, dLat=(lat2-lat1)*Math.PI/180, dLon=(lon2-lon1)*Math.PI/180
      const a = Math.sin(dLat/2)**2 + Math.cos(lat1*Math.PI/180)*Math.cos(lat2*Math.PI/180)*Math.sin(dLon/2)**2
      const distSeg = R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a))
      acumulado += distSeg
      if (acumulado >= ESPACAMENTO_KM && distSeg > 0.01) {
        setas.push({ lat:(lat1+lat2)/2, lon:(lon1+lon2)/2, angulo: calcularBearing(lat1,lon1,lat2,lon2) })
        acumulado = 0
      }
    }
    return setas
  }, [posicoes, kmTotal])

  // Pontos de velocidade espaçados ao longo do trajeto (mostram valor exato ao clicar)
  const pontosVelocidade = React.useMemo(() => {
    if (posicoes.length < 2) return []
    const pontos: { lat:number, lon:number, vel:number, hora:string }[] = []
    const ESPACAMENTO_KM = Math.max(0.5, kmTotal / 25)
    let acumulado = 0
    for (let i = 0; i < posicoes.length - 1; i++) {
      const lat1 = parseFloat(posicoes[i].latitude), lon1 = parseFloat(posicoes[i].longitude)
      const lat2 = parseFloat(posicoes[i+1].latitude), lon2 = parseFloat(posicoes[i+1].longitude)
      if (isNaN(lat1)||isNaN(lat2)) continue
      const R = 6371, dLat=(lat2-lat1)*Math.PI/180, dLon=(lon2-lon1)*Math.PI/180
      const a = Math.sin(dLat/2)**2 + Math.cos(lat1*Math.PI/180)*Math.cos(lat2*Math.PI/180)*Math.sin(dLon/2)**2
      const distSeg = R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a))
      acumulado += distSeg
      if (acumulado >= ESPACAMENTO_KM) {
        pontos.push({ lat:lat1, lon:lon1, vel: parseFloat(posicoes[i].velocidade||0), hora: posicoes[i].data_hora })
        acumulado = 0
      }
    }
    return pontos
  }, [posicoes, kmTotal])

  const centro: [number,number] = [-15.78, -47.93]

  return (
    <div style={{ display:'flex', height:'100%', overflow:'hidden' }}>
      {/* Painel lateral */}
      <div style={{ width:340, background:'#1a2744', borderRight:'1px solid #2d4166', display:'flex', flexDirection:'column', overflow:'hidden' }}>

        {/* Filtros */}
        <div style={{ padding:16, borderBottom:'1px solid #2d4166' }}>
          <div style={{ fontSize:15, fontWeight:700, marginBottom:12 }}>🎬 Replay de trajeto</div>

          {ehSuperadmin && (
            <div className="form-group" style={{ marginBottom:8 }}>
              <label>Cliente</label>
              <select value={clienteSel} onChange={e => { setClienteSel(e.target.value); setAtivoSel('') }}>
                <option value="">— Todos os clientes —</option>
                {clientesLista.map((cl:any) => <option key={cl.id} value={cl.id}>{cl.razao_social||cl.nome}</option>)}
              </select>
            </div>
          )}
          <div className="form-group" style={{ marginBottom:8 }}>
            <label>Veículo</label>
            <select value={ativoSel} onChange={e => setAtivoSel(e.target.value)}>
              <option value="">— Selecione —</option>
              {ativos.filter((a:any) => !clienteSel || a.cliente_id === clienteSel).map((a:any) => <option key={a.id} value={a.id}>{a.nome} {a.placa ? `(${a.placa})` : ''}</option>)}
            </select>
          </div>

          <div style={{ display:'grid', gridTemplateColumns:'1fr', gap:8, marginBottom:8 }}>
            <div className="form-group">
              <label>Data/hora início</label>
              <input type="datetime-local" value={dataInicio} onChange={e => setDataInicio(e.target.value)} />
            </div>
            <div className="form-group">
              <label>Data/hora fim</label>
              <input type="datetime-local" value={dataFim} onChange={e => setDataFim(e.target.value)} />
            </div>
          </div>

          {/* Atalhos de período */}
          <div style={{ display:'flex', gap:4, marginBottom:10, flexWrap:'wrap' }}>
            {[
              { label:'Hoje',    horas:0 },
              { label:'6h',      horas:6 },
              { label:'12h',     horas:12 },
              { label:'24h',     horas:24 },
              { label:'7 dias',  horas:168 },
            ].map(p => (
              <button key={p.label}
                style={{ padding:'3px 8px', borderRadius:6, border:'1px solid #2d4166',
                  background:'transparent', color:'#64748b', fontSize:10, cursor:'pointer', fontFamily:'Inter' }}
                onClick={() => {
                  const fim = new Date()
                  const ini = new Date()
                  if (p.horas === 0) { ini.setHours(0,0,0,0) }
                  else { ini.setHours(ini.getHours() - p.horas) }
                  setDataInicio(ini.toISOString().slice(0,16))
                  setDataFim(fim.toISOString().slice(0,16))
                }}>
                {p.label}
              </button>
            ))}
          </div>

          <div className="form-group">
            <label>Tempo mínimo de parada (minutos)</label>
            <input type="number" min={1} max={120} value={minParada}
              onChange={e => setMinParada(Math.max(1, Number(e.target.value)))}
              style={{ width:'100%' }} />
          </div>
          <button className="btn btn-primary" style={{ width:'100%', justifyContent:'center' }}
            onClick={buscarTrajeto} disabled={loading}>
            {loading ? '⏳ Buscando...' : '🔍 Buscar trajeto'}
          </button>
        </div>

        {/* Controles de replay */}
        {carregandoRota && (
          <div style={{ padding:'8px 16px', background:'rgba(14,165,233,0.1)', borderBottom:'1px solid #2d4166', fontSize:11, color:'#38bdf8', display:'flex', alignItems:'center', gap:6 }}>
            ⏳ Calculando rotas reais nas vias...
          </div>
        )}
        {posicoes.length > 0 && (
          <div style={{ padding:16, borderBottom:'1px solid #2d4166' }}>
            <div style={{ fontSize:12, color:'#64748b', marginBottom:8 }}>
              Posição {posAtual + 1} de {posicoes.length}
            </div>
            <input type="range" min={0} max={posicoes.length-1} value={posAtual}
              onChange={e => { setTocando(false); setPosAtual(Number(e.target.value)) }}
              style={{ width:'100%', marginBottom:10, accentColor:'#0ea5e9' }} />

            <div style={{ display:'flex', gap:8, alignItems:'center', marginBottom:10 }}>
              <button className="btn btn-ghost" style={{ padding:'6px 10px' }}
                onClick={() => setPosAtual(0)}>⏮</button>
              <button className="btn btn-primary" style={{ flex:1, justifyContent:'center' }}
                onClick={() => setTocando(t => !t)}>
                {tocando ? '⏸ Pausar' : '▶ Reproduzir'}
              </button>
              <button className="btn btn-ghost" style={{ padding:'6px 10px' }}
                onClick={() => setPosAtual(posicoes.length-1)}>⏭</button>
            </div>

            <div style={{ display:'flex', alignItems:'center', gap:8 }}>
              <span style={{ fontSize:11, color:'#64748b', whiteSpace:'nowrap' }}>Velocidade:</span>
              <input type="range" min={1} max={50} value={velocidade}
                onChange={e => setVelocidade(Number(e.target.value))}
                style={{ flex:1, accentColor:'#0ea5e9' }} />
              <span style={{ fontSize:11, color:'#0ea5e9', minWidth:30 }}>{velocidade}x</span>
            </div>

            {/* KM Total do trajeto */}
            {posicoes.length > 1 && kmTotal > 0 && (
              <div style={{ background:"#0c2a4a", border:"1px solid #0ea5e9", borderRadius:8, padding:"6px 12px", marginBottom:8, display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                <span style={{ fontSize:11, color:"#64748b" }}>📏 Total do trajeto:</span>
                <span style={{ fontSize:14, fontWeight:700, color:"#0ea5e9" }}>{kmTotal.toFixed(2)} km</span>
              </div>
            )}
            {/* Info ponto atual */}
            {posExibida && (
              <div style={{ background:'#0d1b2e', borderRadius:8, padding:10, marginTop:10 }}>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:6 }}>
                  {[
                    { label:'Velocidade', valor:`${Math.round(posExibida.velocidade||0)} km/h`, cor: corPorVelocidade(posExibida.velocidade||0) },
                    { label:'Ignição',    valor: posExibida.ignicao ? 'Ligada' : 'Desligada', cor: posExibida.ignicao ? '#22c55e' : '#64748b' },
                    { label:'Hodômetro', valor: posExibida.odometro ? `${Math.round(posExibida.odometro)} km` : '—', cor:'#94a3b8' },
                    { label:'Horário',   valor: new Date(posExibida.data_hora).toLocaleTimeString('pt-BR'), cor:'#94a3b8' },
                  ].map((item,i) => (
                    <div key={i} style={{ textAlign:'center' }}>
                      <div style={{ fontSize:12, fontWeight:700, color:item.cor }}>{item.valor}</div>
                      <div style={{ fontSize:9, color:'#475569' }}>{item.label}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}

        {/* Abas de informação */}
        {resumo && (
          <div style={{ flex:1, overflow:'hidden', display:'flex', flexDirection:'column' }}>
            <div style={{ padding:'8px 12px', borderBottom:'1px solid #2d4166', background:'#162035' }}>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:6, marginBottom:6 }}>
                <div style={{ display:'flex', alignItems:'center', gap:4 }}>
                  <span style={{ fontSize:10, color:'#64748b', whiteSpace:'nowrap' }}>⏱ Parada:</span>
                  <input type="number" value={minParada}
                    onChange={e=>setMinParada(Math.max(1,parseInt(e.target.value)||1))}
                    min={1} max={120}
                    style={{ width:45, padding:'2px 4px', fontSize:11, textAlign:'center' }} />
                  <span style={{ fontSize:10, color:'#64748b' }}>min</span>
                </div>
                <div style={{ display:'flex', alignItems:'center', gap:4 }}>
                  <span style={{ fontSize:10, color:'#f59e0b', whiteSpace:'nowrap' }}>🔥 Ocioso:</span>
                  <input type="number" value={minOcioso}
                    onChange={e=>setMinOcioso(Math.max(1,parseInt(e.target.value)||1))}
                    min={1} max={120}
                    style={{ width:45, padding:'2px 4px', fontSize:11, textAlign:'center' }} />
                  <span style={{ fontSize:10, color:'#64748b' }}>min</span>
                </div>
              </div>
              <button onClick={()=>{
                const paroList: any[] = []
                const motorList: any[] = []
                let inicioParada: any = null
                let inicioMotor: any = null
                for (let i = 0; i < posicoes.length; i++) {
                  const vel = parseFloat(posicoes[i].velocidade||0)
                  if (vel < 2) {
                    if (!inicioParada) inicioParada = posicoes[i]
                    if (!inicioMotor) inicioMotor = posicoes[i]
                  } else {
                    if (inicioParada) {
                      const d = (new Date(posicoes[i].data_hora).getTime() - new Date(inicioParada.data_hora).getTime()) / 60000
                      if (d >= minParada) paroList.push({ inicio:inicioParada.data_hora, fim:posicoes[i].data_hora, duracao_min:Math.round(d), latitude:inicioParada.latitude, longitude:inicioParada.longitude, endereco:inicioParada.endereco })
                      inicioParada = null
                    }
                    if (inicioMotor) {
                      const d = (new Date(posicoes[i].data_hora).getTime() - new Date(inicioMotor.data_hora).getTime()) / 60000
                      if (d >= minOcioso) motorList.push({ inicio:inicioMotor.data_hora, fim:posicoes[i].data_hora, duracao_min:Math.round(d), latitude:inicioMotor.latitude, longitude:inicioMotor.longitude })
                      inicioMotor = null
                    }
                  }
                }
                setParadas(paroList)
                setParadasMotor(motorList)
              }} className="btn btn-primary" style={{ fontSize:11, padding:'3px 10px', width:'100%' }}>
                ✅ Aplicar filtros
              </button>
            </div>
            <div style={{ display:'flex', borderBottom:'1px solid #2d4166' }}>
              {(['resumo','velocidade','paradas'] as const).map(aba => (
                <button key={aba} onClick={() => setAbaAtiva(aba)}
                  style={{ flex:1, padding:'8px 4px', border:'none', background:'transparent',
                    color: abaAtiva===aba ? '#38bdf8' : '#64748b', fontSize:11, cursor:'pointer',
                    borderBottom: abaAtiva===aba ? '2px solid #0ea5e9' : '2px solid transparent',
                    fontFamily:'Inter', fontWeight: abaAtiva===aba ? 600 : 400 }}>
                  {aba==='resumo' ? '📊 Resumo' : aba==='velocidade' ? '⚡ Velocidade' : `🅿 Paradas (${paradas.length})`}
                </button>
              ))}
            </div>

            <div style={{ flex:1, overflowY:'auto', padding:16 }}>
              {abaAtiva === 'resumo' && (
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                  {[
                    { label:'Distância percorrida', valor: kmTotal > 0 ? `${kmTotal.toFixed(2)} km` : resumo.distancia_km ? `${parseFloat(resumo.distancia_km).toFixed(1)} km` : '—' },
                    { label:'Duração',       valor: resumo.duracao_min ? formatarTempo(Math.round(resumo.duracao_min)) : '—' },
                    { label:'Vel. média',    valor: resumo.vel_media ? `${parseFloat(resumo.vel_media).toFixed(0)} km/h` : '—' },
                    { label:'Vel. máxima',   valor: resumo.vel_maxima ? `${Math.round(resumo.vel_maxima)} km/h` : '—' },
                    { label:'Total pontos',  valor: resumo.total_pontos || 0 },
                    { label:'Paradas',       valor: paradas.length },
                    { label:'Tempo parado',  valor: formatarTempo(paradas.reduce((a,p)=>a+p.duracao_min,0)) },
                    { label:'🔥 Motor ocioso', valor: formatarTempo(paradas.filter((p:any)=>p.duracao_min>=minOcioso).reduce((a:number,p:any)=>a+p.duracao_min,0)) },
                  ].map((item,i) => (
                    <div key={i} style={{ background:'#0d1b2e', borderRadius:8, padding:'10px 12px' }}>
                      <div style={{ fontSize:14, fontWeight:700, color:'#f1f5f9' }}>{item.valor}</div>
                      <div style={{ fontSize:10, color:'#475569', marginTop:2 }}>{item.label}</div>
                    </div>
                  ))}
                </div>
              )}

              {abaAtiva === 'velocidade' && (
                <div>
                  <div style={{ marginBottom:12 }}>
                    {[
                      { label:'Parado (0 km/h)',      cor:'#64748b', min:0,   max:0 },
                      { label:'Lento (até 40 km/h)',  cor:'#22c55e', min:1,   max:40 },
                      { label:'Médio (40-80 km/h)',   cor:'#f59e0b', min:41,  max:80 },
                      { label:'Rápido (80-110 km/h)', cor:'#ef4444', min:81,  max:110 },
                      { label:'Excesso (>110 km/h)',  cor:'#dc2626', min:111, max:999 },
                    ].map((faixa, i) => {
                      const qtd = posicoes.filter(p => (p.velocidade||0) >= faixa.min && (p.velocidade||0) <= faixa.max).length
                      const pct = posicoes.length > 0 ? Math.round(qtd/posicoes.length*100) : 0
                      return (
                        <div key={i} style={{ marginBottom:10 }}>
                          <div style={{ display:'flex', justifyContent:'space-between', marginBottom:4 }}>
                            <span style={{ fontSize:11, color:'#94a3b8' }}>{faixa.label}</span>
                            <span style={{ fontSize:11, color:faixa.cor, fontWeight:600 }}>{pct}% ({qtd}pts)</span>
                          </div>
                          <div style={{ background:'#0d1b2e', borderRadius:4, height:6, overflow:'hidden' }}>
                            <div style={{ width:`${pct}%`, height:'100%', background:faixa.cor, borderRadius:4, transition:'width 0.5s' }} />
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              )}

              {abaAtiva === 'paradas' && (
                <div>
                  {paradas.length === 0 ? (
                    <div style={{ textAlign:'center', color:'#64748b', fontSize:13, padding:16 }}>
                      Nenhuma parada detectada neste período
                    </div>
                  ) : paradas.map((p, i) => (
                    <div key={i} style={{ background:'#0d1b2e', borderRadius:8, padding:10, marginBottom:8 }}>
                      <div style={{ display:'flex', justifyContent:'space-between', marginBottom:4 }}>
                        <span style={{ fontSize:12, fontWeight:600, color:'#f59e0b' }}>
                          🅿 Parada {i+1} — {formatarTempo(p.duracao_min)}
                        </span>
                      </div>
                      <div style={{ fontSize:11, color:'#64748b' }}>
                        {new Date(p.inicio).toLocaleTimeString('pt-BR')} → {new Date(p.fim).toLocaleTimeString('pt-BR')}
                      </div>
                      {p.endereco && <div style={{ fontSize:10, color:'#475569', marginTop:3 }}>📍 {p.endereco}</div>}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {!resumo && !loading && (
          <div style={{ flex:1, display:'flex', alignItems:'center', justifyContent:'center', padding:24 }}>
            <div style={{ textAlign:'center', color:'#475569' }}>
              <div style={{ fontSize:40, marginBottom:12 }}>🎬</div>
              <div style={{ fontSize:13 }}>Selecione um veículo e o período para visualizar o trajeto</div>
            </div>
          </div>
        )}
      </div>

      {/* Mapa */}
      <div style={{ flex:1, position:'relative' }}>
        <MapContainer center={centro} zoom={5} style={{ width:'100%', height:'100%' }}>
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

          {posicoes.length > 1 && <AjustarBounds pontos={posicoes} />}

          {/* Linha do trajeto — segmentos roteados (OSRM) quando disponíveis, com destaque para gaps suspeitos */}
          {segmentosRota.length > 0 && segmentosRota.map((seg, i) => (
            <Polyline key={`rota-carregada-${segmentosRota.length}-${i}`} positions={seg.pontos}
              pathOptions={seg.suspeito
                ? { color:'#ef4444', weight:4, opacity:0.85, dashArray:'8,8', lineCap:'round' }
                : { color:'#0ea5e9', weight:5, opacity:0.7, lineCap:'round', lineJoin:'round' }
              } />
          ))}
          {segmentosRota.length === 0 && linhaCompleta.length > 1 && (
            <Polyline key="rota-fallback" positions={linhaCompleta}
              pathOptions={{ color:'#0ea5e9', weight:5, opacity:0.45, lineCap:'round', lineJoin:'round' }} />
          )}
          {/* Setas indicando o sentido do trajeto */}
          {setasSentido.map((s, i) => (
            <Marker key={`seta-${i}`} position={[s.lat, s.lon]}
              icon={L.divIcon({
                html:`<div style="transform:rotate(${s.angulo}deg);width:18px;height:18px;display:flex;align-items:center;justify-content:center;">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M12 2 L20 18 L12 14 L4 18 Z" fill="#f1f5f9" stroke="#0ea5e9" stroke-width="1.2" stroke-linejoin="round"/>
                  </svg>
                </div>`,
                className:'', iconSize:[18,18], iconAnchor:[9,9]
              })} />
          ))}

          {/* Ponto inicial */}
          {posicoes.length > 0 && (
            <Marker position={[posicoes[0].latitude, posicoes[0].longitude]}
              icon={L.divIcon({ html:'<div style="background:#22c55e;width:16px;height:16px;border-radius:50%;border:3px solid white;box-shadow:0 2px 6px rgba(0,0,0,0.4)"></div>', className:'', iconSize:[16,16], iconAnchor:[8,8] })}>
              <Popup><strong>Início</strong><br />{new Date(posicoes[0].data_hora).toLocaleString('pt-BR')}</Popup>
            </Marker>
          )}

          {/* Ponto final */}
          {posicoes.length > 1 && (
            <Marker position={[posicoes[posicoes.length-1].latitude, posicoes[posicoes.length-1].longitude]}
              icon={L.divIcon({ html:'<div style="background:#ef4444;width:16px;height:16px;border-radius:50%;border:3px solid white;box-shadow:0 2px 6px rgba(0,0,0,0.4)"></div>', className:'', iconSize:[16,16], iconAnchor:[8,8] })}>
              <Popup><strong>Fim</strong><br />{new Date(posicoes[posicoes.length-1].data_hora).toLocaleString('pt-BR')}</Popup>
            </Marker>
          )}

          {/* Pontos de velocidade espaçados — clique para ver o valor */}
          {pontosVelocidade.map((pv, i) => (
            <Marker key={`vel-${i}`} position={[pv.lat, pv.lon]}
              icon={L.divIcon({
                html:`<div style="width:9px;height:9px;border-radius:50%;background:${corPorVelocidade(pv.vel)};border:2px solid white;box-shadow:0 1px 3px rgba(0,0,0,0.4);"></div>`,
                className:'', iconSize:[9,9], iconAnchor:[4,4]
              })}>
              <Popup>
                <strong>{Math.round(pv.vel)} km/h</strong><br/>
                {new Date(pv.hora).toLocaleTimeString('pt-BR')}
              </Popup>
            </Marker>
          ))}
          {/* Posição atual no replay */}
          {posExibida && (
            <Marker position={[posExibida.latitude, posExibida.longitude]}
              icon={L.divIcon({
                html:`<div style="background:${corPorVelocidade(posExibida.velocidade||0)};width:20px;height:20px;border-radius:50%;border:3px solid white;box-shadow:0 2px 8px rgba(0,0,0,0.5);display:flex;align-items:center;justify-content:center;font-size:10px;color:white;font-weight:bold">${Math.round(posExibida.velocidade||0)}</div>`,
                className:'', iconSize:[20,20], iconAnchor:[10,10]
              })}>
              <Popup>
                <strong>{Math.round(posExibida.velocidade||0)} km/h</strong><br />
                {new Date(posExibida.data_hora).toLocaleString('pt-BR')}
              </Popup>
            </Marker>
          )}

          {/* Marcadores de parada — estilo placa de trânsito PARE */}
          {paradas.map((p, i) => (
            <Marker key={i} position={[p.latitude, p.longitude]}
              icon={L.divIcon({
                html:`
                  <div style="display:flex;flex-direction:column;align-items:center;">
                    <svg width="36" height="36" viewBox="0 0 100 100" style="filter:drop-shadow(0 2px 4px rgba(0,0,0,0.5));">
                      <polygon points="29,4 71,4 96,29 96,71 71,96 29,96 4,71 4,29"
                        fill="#dc2626" stroke="white" stroke-width="6"/>
                      <text x="50" y="58" font-family="Arial, sans-serif" font-size="26" font-weight="800"
                        fill="white" text-anchor="middle" letter-spacing="-1">PARE</text>
                    </svg>
                    <div style="margin-top:1px;background:#1e293b;color:white;font-size:9px;font-weight:700;
                      padding:1px 6px;border-radius:8px;white-space:nowrap;box-shadow:0 1px 4px rgba(0,0,0,0.3);">
                      ${formatarTempo(p.duracao_min)}
                    </div>
                  </div>`,
                className:'', iconSize:[40,52], iconAnchor:[20,26]
              })}>
              <Popup>
                <strong>🛑 Parada {i+1}</strong><br />
                Duração: {formatarTempo(p.duracao_min)}<br />
                Motor: {p.motor_ligado ? '🟢 Ligado' : '⚪ Desligado'}<br />
                {new Date(p.inicio).toLocaleTimeString('pt-BR')} → {new Date(p.fim).toLocaleTimeString('pt-BR')}<br />
                {p.endereco && <span>📍 {p.endereco}</span>}
              </Popup>
            </Marker>
          ))}
        </MapContainer>

        {/* Legenda de velocidade */}
        {posicoes.length > 0 && (
          <div style={{ position:'absolute', bottom:20, left:20, zIndex:1000,
            background:'rgba(30,47,74,0.95)', border:'1px solid #2d4166',
            borderRadius:10, padding:'10px 14px', fontSize:11 }}>
            <div style={{ fontWeight:600, color:'#94a3b8', marginBottom:6 }}>Velocidade</div>
            {[
              { cor:'#64748b', label:'Parado' },
              { cor:'#22c55e', label:'Até 40 km/h' },
              { cor:'#eab308', label:'41-80 km/h' },
              { cor:'#f97316', label:'81-110 km/h' },
              { cor:'#ef4444', label:'Acima 110' },
            ].map((item,i) => (
              <div key={i} style={{ display:'flex', alignItems:'center', gap:7, marginBottom:4 }}>
                <div style={{ width:11, height:11, borderRadius:'50%', background:item.cor, border:'2px solid white', boxShadow:'0 1px 3px rgba(0,0,0,0.4)' }} />
                <span style={{ color:'#94a3b8' }}>{item.label}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
